import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import Link from '../../elements/Comfirmapprove';
import { actions } from '../../../state/assessment';

const mapStateToProps = state => ({
  status: state.shift.status,
  popwindow: state.shift.status.popwindow
});

const mapDispatchToProps = dispatch => ({
  onClose: () => {
    dispatch(actions.setpopflagfalse());
  }
});

const Comfirm = connect(
  mapStateToProps,
  mapDispatchToProps
)(Link);

export default Comfirm;



// WEBPACK FOOTER //
// ./src/components/container/Comfirmapprove/index.js